import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'antd';
import { borderProps, paddingProps, marginProps } from './props';

/* eslint-disable no-unused-vars*/
const CustomButton = ({
  className,
  dark,
  light,
  right,
  link,
  marginLeft,
  marginRight,
  activeColor,
  ...rest
}) => {
  if (link) {
    return <Button className={className} onClick={() => window.open(link, '_blank')} {...rest} />;
  }
  return <Button className={className} {...rest} />;
};

CustomButton.propTypes = {
  className: PropTypes.string.isRequired,
  dark: PropTypes.bool,
  light: PropTypes.bool,
  right: PropTypes.bool,
  link: PropTypes.string,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  activeColor: PropTypes.string,
};

const secondary = (p) => {
  const {
    theme: { colors },
    theme,
    dark,
    light,
    activeColor,
  } = p;
  let backgroundColor = colors.themeSecondary;
  if (dark) {
    backgroundColor = colors.darkThemeSecondary;
  }
  if (light) {
    backgroundColor = '#fff';
  }
  if (activeColor) {
    backgroundColor = activeColor;
  }
  return css`
    background-color: ${`${backgroundColor} !important`};
    color: ${light ? `${colors.darkThemeSecondary} !important` : '#fff !important'};
    border-color: ${light ? `${colors.darkThemeSecondary} !important` : 'transparent !important'};
    font-weight: ${theme.fontWeight.bold};
    font-size: 13px;
    height: 34px;
    ${borderProps};
    ${paddingProps};
    ${marginProps};

    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.3;
    }
  `;
};

export default styled(CustomButton)`
  color: ${p => p.theme.colors ? p.theme.colors.text : '#313b40'};
  box-shadow: ${p => p.flat && 'none !important'};
  ${p => p.type === 'secondary' && secondary};
`;
